<div *transloco="let t; read: 'loading'" class="h-screen w-screen bg-slate-100 opacity-80">
    <div class="loading-spinner">
        <div class="loading-text text-2xl font-bold">
            {{ t('generateIsInProgress') }}
        </div>
        <div class="dots">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
        </div>
    </div>
</div>
